export default {
      id: "icon-xmark-solid-usage",
      viewBox: "0 0 320 512",
      url: __webpack_public_path__ + "icons.svg#icon-xmark-solid",
      toString: function () {
        return this.url;
      }
    }